const Conditions = (props) => {
  let conditions = props.data?.conditions;
  let conditions_override = props.data?.conditions_override;
  let conditionText = "";
  if (conditions_override && conditions_override.length > 0){
    for(var i = 0; i < conditions_override.length; i++){
      let tempCond = conditions_override[i];
      conditionText += tempCond.name
      if(i < conditions_override.length - 1){
        conditionText += ", "
      }
    }
  }
  else if (conditions && conditions.length > 0) {
    for(var i = 0; i < conditions.length; i++){
      let tempCond = conditions[i];
      conditionText += tempCond.name
      if(i < conditions.length - 1){
        conditionText += ", "
      }
    }

  }
  return (
    <div>{conditionText}</div>
  );
};

export default Conditions;